import { Directive, ElementRef, Host } from '@angular/core';
import { BsDaterangepickerDirective } from 'ngx-bootstrap';

@Directive({ selector: '[ce-date-range-picker]' })
export class CeDateRangePickerDirective {
    constructor(
        @Host() private bsDaterangepicker: BsDaterangepickerDirective,
        private el: ElementRef
    ) {
        this.el.nativeElement.placeholder = "mm/dd/yyyy - mm/dd/yyyy";
        this.bsDaterangepicker.placement = "right";
        this.bsDaterangepicker.bsConfig = {
            ...this.bsDaterangepicker.bsConfig,
            containerClass: "theme-dark-blue",
            showWeekNumbers: false,
            displayMonths: 1
        };
    }
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/shared/directives/ce-date-range-picker.directive.ts